import BaseFormPresenter from "../../../base/BaseFormPresenter";

class ClientInfoPresenter extends BaseFormPresenter {
    constructor(view, getObjectUseCase, upsertUseCase, findObjectUseCase) {
        super(view, getObjectUseCase, upsertUseCase);
        this.findObjectUseCase = findObjectUseCase;
    }

    async getObject() {
        const collection = this.view.getCollectionName();
        const id = this.object.id || this.view.getObjectId();

        if (id) {
            try {
                this.view.showProgress();

                const client = await this.getObjectUseCase.execute(collection, id);
                this.object = client;
                this.view.setObject(client);
                this.view.hideProgress();

                const filter = {
                    where: {
                        client: { id: client.id }
                    }
                };

                const inquiries = await this.findObjectUseCase.execute("inquiries", filter);
                this.view.setState({ inquiries });

            } catch (error) {
                this.view.hideProgress();
                this.view.showError(error);
            }
        }
    }
}

export default ClientInfoPresenter;
